import { createApp } from "vue";
import App from "./App.vue";
import { createPinia } from "pinia";
const pinia = createPinia();
import "../../components/dist/components.es.js";
import { configurePrimeVue } from "@shared/configs/primeVueConfig.js";
import { configurePlugins } from "@shared/plugins";
import "bootstrap";
import router from "./router";
import i18n from "./i18n";
import mixin from "@shared/mixins/helperMixin";
import InlineSvg from "vue-inline-svg"; //
import "primevue/resources/themes/aura-light-green/theme.css";
import "primevue/resources/primevue.min.css";

import "@shared/assets/scss/config/default/app.scss";
import "@shared/assets/scss/custom.scss";
import "@shared/assets/scss/global.scss";

const remoteUrl = "https://vietnamtourist.me:8081/remoteEntry.js";
// const remoteUrl2 = "https://vietnamtourist.me::8083/remoteEntryTimesheet.js";
const remoteUrl3 = "https://vietnamtourist.me:8083/remoteEntry.js";
const remoteUrl4 = "https://vietnamtourist.me:8085/remoteEntry.js";
function loadRemote() {
  return import(/* webpackIgnore: true */ remoteUrl)
   //.then(() => import(/* webpackIgnore: true */ remoteUrl2))
   .then(() => import(/* webpackIgnore: true */ remoteUrl3))
   .then(() => import(/* webpackIgnore: true */ remoteUrl4));
}

loadRemote()
  .then(() => {
    const app = createApp(App);

    app.component("inline-svg", InlineSvg);
    app.mixin(mixin).use(pinia).use(router).use(i18n);
    configurePrimeVue(app);
    configurePlugins(app);
    app.mount("#app");
  })
  .catch((e, status) => {
    if (status == undefined) {
      const app = createApp(App);
      app.component("inline-svg", InlineSvg);
      app.mixin(mixin).use(pinia).use(router).use(i18n).mount("#app");
    }
  });
